"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fit = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fit =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "e1ch6bqf0"
})("flex:0;");
exports.Fit = Fit;
Fit.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  style: _propTypes.default.object
};


//////////////////
// WEBPACK FOOTER
// ./~/spectacle/lib/components/fit.js
// module id = 998
// module chunks = 32308089046778